import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Page from '../../../layout/Page/Page';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Input from '../../../components/bootstrap/forms/Input';
import Button from '../../../components/bootstrap/Button';
import useDarkMode from '../../../hooks/useDarkMode';
import { useFormik } from 'formik';
import AuthContext from '../../../contexts/authContext';
import Spinner from '../../../components/bootstrap/Spinner';

import logo from '../../../assets/logos/logoo.svg';

import newLogo from '../../../assets/logos/essuivi.svg';


import Icon from '../../../components/icon/Icon';
import { login } from '../../../apis/backend/auth';
import { useNavigate } from 'react-router-dom';

const Login = () => {
	const { setLoading, loading, userData } = useContext(AuthContext);

	const { darkModeStatus } = useDarkMode();
	const [isLoading, setisLoading] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const navigate = useNavigate();
	const formik = useFormik({
		enableReinitialize: false,
		initialValues: {
			loginUsername: '',
			loginPassword: '',
			rememberMe: true, // ✅ new

		},
		validate: (values) => {
			const errors = {};

			if (!values.loginUsername) {
				errors.loginUsername = 'Requis';
			}

			if (!values.loginPassword) {
				errors.loginPassword = 'Requis';
			}

			return errors;
		},
		validateOnChange: false,
		onSubmit: async (values) => {
			setisLoading(true);

			// ✅ remember me storage
			if (values.rememberMe) {
				localStorage.setItem("rememberedUsername", values.loginUsername);
				localStorage.setItem("rememberedPwd", values.loginPassword);
			} else {
				localStorage.removeItem("rememberedUsername");
				localStorage.removeItem("rememberedPwd");
			}

			handleSubmit(values);
		},
	});

	const handleSubmit = (values) => {
		login(
			{
				userName: values?.loginUsername,
				password: values?.loginPassword,
			},
			async () => {
				setisLoading(false);
				// window.location.href = '/';

				setLoading(true);
				navigate('/planning');
			},
			(errorMsg) => {
				setisLoading(false);
				alert(errorMsg);
			},
		);
	};

	useEffect(() => {
		const savedUsername = localStorage.getItem("rememberedUsername");
		const savedPwd = localStorage.getItem("rememberedPwd");
		if (savedUsername) {
			formik.setFieldValue("loginUsername", savedUsername, false);
			formik.setFieldValue("loginPassword", savedPwd, false);
			formik.setFieldValue("rememberMe", true, false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<PageWrapper title={'Login'} className='bg-primary'>
			<Page className='p-0'>
				<div className='row h-100 align-items-center justify-content-center'>
					<div className='col-xl-4 col-lg-6 col-md-8 shadow-3d-container'>
						<Card className='shadow-3d-dark' data-tour='login-page'>
							<CardBody>
								<div className='text-center '>
									<img src={newLogo} alt='logo' width={300} height={200} />
								</div>

								<div
									className={classNames('rounded-3', {
										'bg-l10-dark': !darkModeStatus,
										'bg-dark': darkModeStatus,
									})}></div>

								<form className='row g-4' onSubmit={formik.handleSubmit}>
									<>
										<div className='col-12'>
											<FormGroup
												id='loginUsername'
												isFloating
												label="Nom d'utilisateur">
												<Input
													name='loginUsername'
													autoComplete='username'
													value={formik.values.loginUsername}
													isTouched={formik.touched.loginUsername}
													invalidFeedback={formik.errors.loginUsername}
													isValid={formik.isValid}
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
													onFocus={() => {
														formik.setErrors({});
													}}
												/>
											</FormGroup>

											<FormGroup
												id='loginPassword'
												isFloating
												label='Mot de passe'
												className='mt-2 d-flex align-items-center bg-l10-info rounded-2 pe-3'>
												<Input
													name='loginPassword'
													className='border-0 bg-transparent'
													type={showPassword ? 'text' : 'password'}
													autoComplete='current-password'
													value={formik.values.loginPassword}
													isTouched={formik.touched.loginPassword}
													invalidFeedback={formik.errors.loginPassword}
													validFeedback='Bon!'
													isValid={formik.isValid}
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
												/>

												<Icon
													size={'lg'}
													className='cursor-pointer'
													icon={'RemoveRedEye'}
													onClick={() =>
														setShowPassword(!showPassword)
													}></Icon>
											</FormGroup>
										</div>
										{/* Remember me */}
										<div className="col-12 d-flex align-items-center justify-content-between">
											<div className="form-check">
												<input
													className="form-check-input"
													type="checkbox"
													id="rememberMe"
													name="rememberMe"
													checked={formik.values.rememberMe}
													onChange={formik.handleChange}
												/>
												<label className="form-check-label" htmlFor="rememberMe">
													Se souvenir de moi
												</label>
											</div>
										</div>
										<div className='col-12'>
											<Button type="submit"
												color='primary'
												className='w-100 py-3'
												// onClick={formik.handleSubmit}
												isDisable={isLoading}>
												{(isLoading || loading) && (
													<Spinner isSmall inButton />
												)}
												Connexion
											</Button>
										</div>
									</>
								</form>
							</CardBody>
						</Card>
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};
Login.propTypes = {
	isSignUp: PropTypes.bool,
};
Login.defaultProps = {
	isSignUp: false,
};

export default Login;
